import { render, staticRenderFns } from "./SendTreeRequest.vue?vue&type=template&id=22d40056"
import script from "./SendTreeRequest.vue?vue&type=script&lang=ts"
export * from "./SendTreeRequest.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports